import Cookies from 'js-cookie';

export const getLocaleLanguage = () => {
    return Cookies.get('i18next') || 'fr';
};
